/* HTML
<div data-js="accordion">
<button aria-controls="accordionId" data-js="accordion-trigger" aria-expanded="false"></button>
<div id="accordionId" data-js="accordion_panel">
<div>your contents this can be any html element you want</div>
</div>
</div>
*/

/* SCSS
[data-js="accordion"] {
  display: flex;
  flex-direction: column;
  [data-js="accordion_panel"] {
    max-height: 0px;
    overflow: hidden;
    transition: max-height 0.25s ease-in-out;
  }
}
*/

/* USE
To use the function you need to specify 3 arguments:
1) container: if you follow the html above it would be [data-js="accordion"] in case you want to have in the same page accordion groups that you want to open close the accordions of one group without interfere with the accordions of th other group you must give a group (if you want by default it will select the parent node).
2) closeActives: boolean for the behavior of the accordions in a group. True if you want to close the active accordion when you click to open another. You should specify a selector for group (if you want by default it will select the parent node). False if you want to close the accordion only when you click again in the accordion's toggler.
By default the behavior is set to true.
3) Optional, give the index of a accordion with activetoggle function that you want to be open on load (import activeToggle from "./components/activeAccordion.js";)

document.querySelectorAll('[data-js="accordion"]').forEach((elem) => {
  accordion(elem, true, group);
});

TO SET AN ACCORDION ACTIVE YOU IMPORT THE "activeAccordion.js" and run the function below
activeToggle(accordions[0]);
*/

function accordionEduc(container, closeActives = true, group) {
  const contentsElement = container.querySelector(
    '[data-js="accordion_panel"] > *'
  );
  const accordionsHeight = container.querySelector(
    '[data-js="accordion_panel"]'
  );

  // Check if accordion needs the toggle functionality
  if (
    parseInt(getComputedStyle(accordionsHeight).maxHeight, 10) -
      contentsElement.offsetHeight >
    -50
  ) {
    container.classList.add("noNeed");
  }

  // Add event listeners to all toggler buttons
  const togglers = container.querySelectorAll('[data-js="accordion-trigger"]');
  togglers.forEach((element) => {
    element.addEventListener("click", function (e) {
      e.preventDefault();
      toggleState(container, group);
    });
  });

  function toggleState(target, group = target.parentNode) {
    const panel = target.querySelector('[data-js="accordion_panel"]');
    const button = target.querySelector('[data-js="accordion-trigger"]');
    const panelHeight = panel.scrollHeight;

    const isExpanded = button.getAttribute("aria-expanded") === "true";

    // Close the current panel if it's expanded
    if (isExpanded) {
      button.setAttribute("aria-expanded", "false");
    } else {
      // Close other active panels if needed
      if (closeActives && group) {
        const openAccordion = group.querySelector('[aria-expanded="true"]');
        if (openAccordion) {
          toggleState(openAccordion.parentNode, group);
        }
      }

      // Open the target panel
      button.setAttribute("aria-expanded", "true");
    }
  }
}


// function accordionEduc(container, closeActives = true, group) {
//   const contentsElement = container.querySelector(
//     '[data-js="accordion_panel"] > *'
//   );
//   const accordionsHeight = container.querySelector(
//     '[data-js="accordion_panel"]'
//   );

//   // Check if height of contents bigger from accordions max height. If their difference is less than 150px I add the class noNeed to the container and with css I set the max-height to unset and the button to display none;

//   if (
//     parseInt(getComputedStyle(accordionsHeight).maxHeight, 10) -
//     contentsElement.offsetHeight >
//     -50
//   ) {
//     container.classList.add("noNeed");
//   }
//   // container
//   //   .querySelector('[data-js="accordion-trigger"]')
//   //   .addEventListener("click", function (e) {
//   //     e.preventDefault();
//   //     toggleState(container);
//   const togglers = container.querySelectorAll('[data-js="accordion-trigger"]');
//   togglers.forEach((element) => {
//     element.addEventListener("click", function (e) {
//       e.preventDefault();
//       toggleState(container, group);
//     });
//   });

//   function toggleState(target, group = target.parentNode) {
//     const panel = target.querySelector('[data-js="accordion_panel"]');
//     const button = target.querySelector('[data-js="accordion-trigger"]')
//     let panelHeight = () => panel.scrollHeight;
//     if (button.getAttribute('aria-expanded') == "true") {
//       button.setAttribute('aria-expanded', "false")
//     } else {
//       if (closeActives) {
//         let openAccordion = group.querySelector('[aria-expanded="true"]');
//         if (openAccordion) {
//           toggleState(openAccordion.parentNode);
//         }
//       }
//       // target.classList.add("active");
//       button.setAttribute('aria-expanded', "true");
//       // panel.setAttribute('aria-expanded', "true");
//     }
//     if (panel.style.maxHeight) {
//       panel.style.maxHeight = null;
//     } else {
//       panel.style.maxHeight = panelHeight() + "px";
//     }
//   }
// }



export default accordionEduc;
